import './index.css';
import { useState, useRef, useEffect } from 'react';

const useSelectOptionsList = (isMobile) => {
    const [showOptions, setShowOptions] = useState(false);
    const activatorRef = useRef(null);
    const optionsListRef = useRef(null);
    useEffect(() => {
        if (!showOptions || isMobile) {
            return void 0;
        }
        const isSelectContainsElement = (element) => {
            return activatorRef.current?.contains(element) || optionsListRef.current?.contains(element);
        };
        const clickHandler = (event) => {
            if (isSelectContainsElement(event.target)) {
                return;
            }
            document.removeEventListener('click', clickHandler, true);
            setShowOptions(false);
        };
        const focusHandler = (event) => {
            if (isSelectContainsElement(event.target)) {
                return;
            }
            document.removeEventListener('focus', focusHandler, true);
            setShowOptions(false);
        };
        document.addEventListener('focus', focusHandler, true);
        document.addEventListener('click', clickHandler, true);
        return () => {
            document.removeEventListener('focus', focusHandler, true);
            document.removeEventListener('click', clickHandler, true);
        };
    }, [isMobile, optionsListRef, showOptions]);
    const onOptionsListClose = () => setShowOptions(false);
    const toggleListVisibility = () => setShowOptions((showOptions) => !showOptions);
    return {
        activatorRef,
        optionsListRef,
        onOptionsListClose,
        toggleListVisibility,
        showOptions,
    };
};

export { useSelectOptionsList };
//# sourceMappingURL=useSelectOptionsList.js.map
